import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AgencyDto, AgencyResponseDto, AgencyUserDto, CreateAgencyDto } from '@/app/common/general-types/agency.dto';
import { FiltersGenericDto } from '@/app/services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {

  private http = inject(HttpClient);

  updateAgencyAccountPartial(agencyId: string, updateData: Partial<Pick<AgencyDto, 'name' | 'website' | 'about'>>): Observable<AgencyDto> {
    const update_agency_account_partial_url = `${environment.shout_api.url}/agencies/${agencyId}`;
    return this.http.put<AgencyDto>(update_agency_account_partial_url, updateData, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getAgencyUsers(agencyId: string): Observable<AgencyUserDto[]> {
    const get_agency_users_url = `${environment.shout_api.url}/agencies/users/${agencyId}`;
    return this.http.get<AgencyUserDto[]>(get_agency_users_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  createAgency(agency: CreateAgencyDto) {
    const create_agency_url = `${environment.shout_api.url}/agencies`;
    return this.http.post(create_agency_url, agency, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  associateAgencyToUser(agency: CreateAgencyDto, userId: string) {
    const associate_agency_to_user_url = `${environment.shout_api.url}/registration/associate-agency-to-user-nested`;
    return this.http.post(associate_agency_to_user_url, { agency, userId }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getInsightsAgencies(filters: FiltersGenericDto): Observable<AgencyResponseDto> {
    const get_insights_agencies_url = `${environment.shout_api.url}/agencies/insights/agencies`;
    return this.http.post<AgencyResponseDto>(get_insights_agencies_url, filters, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getAgencyById(agencyId: string): Observable<AgencyDto> {
    const get_agency_url = `${environment.shout_api.url}/agencies/${agencyId}`;
    return this.http.get<AgencyDto>(get_agency_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
}
